import { useState } from 'react';
import { colorFor, initials } from '../lib/artists';
import { useIsSaved, useToggleSaved } from '../lib/savedArtists';
import { CheckIcon, PlusIcon } from './Icons';

export function ArtistAvatar({
  name,
  image,
  size,
  fontSize,
}: {
  name: string;
  image: string | null | undefined;
  size: number;
  fontSize?: number;
}) {
  const [failed, setFailed] = useState(false);
  if (image && !failed) {
    return (
      <img
        className="avatar"
        src={image}
        alt=""
        width={size}
        height={size}
        loading="lazy"
        decoding="async"
        onError={() => setFailed(true)}
        style={{ width: size, height: size }}
      />
    );
  }
  return (
    <span
      className="avatar"
      aria-hidden="true"
      style={{ width: size, height: size, background: colorFor(name), fontSize: fontSize ?? Math.round(size * 0.36) }}
    >
      {initials(name)}
    </span>
  );
}

/**
 * Add to / In My Artists toggle (FR-A2, FR-S2, FR-M3). One click, no confirmation; signed-out
 * users get the sign-in prompt and the add completes afterwards.
 */
export function LibButton({
  artist,
  compact = false,
  labels = { on: 'In My Artists', off: 'Add to My Artists' },
}: {
  artist: { id: string; name: string; imageUrl: string | null };
  compact?: boolean;
  labels?: { on: string; off: string };
}) {
  const saved = useIsSaved(artist.id);
  const toggle = useToggleSaved();
  return (
    <button
      type="button"
      className={`lib-btn${compact ? ' compact' : ''}`}
      aria-pressed={saved}
      aria-label={compact ? (saved ? `${artist.name} is in My Artists. Remove.` : `Add ${artist.name} to My Artists`) : undefined}
      onClick={() => toggle(artist)}
    >
      {saved ? <CheckIcon /> : <PlusIcon />}
      {saved ? labels.on : labels.off}
    </button>
  );
}
